import React, { useState, useEffect } from "react";
import Select from "react-select";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";

const CostTypePopup = ({ closePopup, editData,triggerReload }) => {
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (editData?.id) {
      const fetchData = async () => {
        try {
          const response = await axiosInstance.get(`/costsolution/costtype/get/${editData.id}`);
          const data = response.data;

          setCode(data.costtype?.code || "");
          setName(data.costtype?.name || "");
          setCategory(data.costtype?.subCategory || "");
          setIsEditing(true);
        } catch (error) {
          console.error("Error fetching data:", error);
          toast.error("Error fetching details");
        }
      };
      fetchData();
    }
  }, [editData?.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = { code, name };

    try {
      const url = isEditing
        ? `/costsolution/costtype/${editData?.id}`
        : "/costsolution/costtype";

      const response = await axiosInstance({
        method: isEditing ? "put" : "post",
        url,
        data: postData,
      });

      if (response.data) {
        toast.success(isEditing ? "Cost Type Updated Successfully!" : "Cost Type Saved Successfully!");
        triggerReload(); 
        setCode("");
        setName("");
        setCategory("");
        closePopup();
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error("Something went wrong!");
    }
  };

  const handleClear = () => {
    setCode("");
    setName("");
    setCategory("");
  };

  const fetchData = async (url, setState) => {
    try {
      const response = await axiosInstance.get(url);
      const data = response.data;

      if (data.success && Array.isArray(data.autosuggestion)) {
        setState(data.autosuggestion.map((item) => ({
          label: item.label,
          value: item.value,
        })));
      } else {
        setState([]);
      }
    } catch (error) {
      console.error("Suggestion fetch error:", error);
      setState([]);
    }
  };

  useEffect(() => {
    fetchData("/costsolution/scope/autosuggestion", setSuggestions);
  }, []);

  return (
    <div className="scope-creation-popup-overlay">
      <div className="scope-creation-popup-container">
         <div className="scope-creation-popup-header">
          <h2>{isEditing ? "Edit Cost Type" : "Create Cost Type"}</h2>
          <button className="close-button" onClick={closePopup}>
            ×
          </button>
        </div>
       
        <form onSubmit={handleSubmit}>
        <div className="scope-creation-popup-body">
        <div className="scope-creation-form-group">
          <label htmlFor="code" className="labels">Code</label>
          <input type="text" id="code" value={code} onChange={(e) => setCode(e.target.value)} required style={{ margin: "0px" }}/>
          </div>
        
          <div className="scope-creation-form-group">
          <label htmlFor="name" className="name">Name</label>
          <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} required style={{ margin: "0px" }}/>
        </div>

        {/* <div className="scope-creation-form-group">
          <label htmlFor="scope" className="scope">Subcategory</label>
          <Select
            id="category"
            options={suggestions}
            value={suggestions.find((s) => s.value === category) || null}
            onChange={(selected) => setCategory(selected?.value || "")}
            placeholder="Select Scope..."
            isSearchable
            menuPosition="fixed"
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                    ...base,
                    width: '100%',
                    minHeight: '37px',
                    borderRadius: '6px',
                    borderColor: '#D0D6DF',
                    fontSize: '13px',
                    '&:hover': {
                        borderColor: '#454CF2'
                    },
                    
                }),
                container: (base) => ({
                    ...base,
                    width: '100%',
                    marginBottom:'15px',
                    
                }),
                menu: (base) => ({
                    ...base,
                    fontSize: '13px'
                })
            }}
          />
          </div> */}
          </div>

          <div className="scope-creation-popup-footer">
            <button type="button" className="clear-button" onClick={handleClear}>
              Clear
            </button>
            <button type="submit" className="submit-button">
              {isEditing ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CostTypePopup;
